import { forwardRef, type Ref, type SVGProps } from "react";
const IconDrawOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 28h-1a2.84 2.84 0 0 1-1.62-.52 9.9 9.9 0 0 0 1.75-5.43 5.06 5.06 0 0 0-.67-2.7 2.91 2.91 0 0 0-4.92 0 5.06 5.06 0 0 0-.67 2.7 9.9 9.9 0 0 0 1.75 5.43 2.16 2.16 0 0 1-3.14-.36 4 4 0 0 1-.4-.66 5.5 5.5 0 0 0 .3-1.68c0-1.31-.75-1.78-1.38-1.78s-1.38.47-1.38 1.78a5.5 5.5 0 0 0 .3 1.68 4 4 0 0 1-.4.66A1.91 1.91 0 0 1 16 28H9.71l15.71-15.71 4.28-4.28a1 1 0 0 0 0-1.43L25.42 2.3a1 1 0 0 0-.71-.3 1.02 1.02 0 0 0-.72.3L3.01 23.28a.5.5 0 0 0-.06.1.7.7 0 0 0-.12.17 1 1 0 0 0-.07.19l-.04.11-.71 5V29a1 1 0 0 0 .04.22A.9.9 0 0 0 3 30h13a3.84 3.84 0 0 0 3-1.53A3.82 3.82 0 0 0 22 30a4.83 4.83 0 0 0 3-1.05A4.83 4.83 0 0 0 28 30h1a1 1 0 0 0 0-2M24.71 4.44l2.85 2.85-2.85 2.86-2.86-2.86zM4.68 24.47 20.43 8.72l2.85 2.85L7.53 27.32l-3.33.48zM25 25.95a7.93 7.93 0 0 1-1.13-3.9 3.16 3.16 0 0 1 .36-1.63.91.91 0 0 1 1.54 0 3.16 3.16 0 0 1 .36 1.63 7.93 7.93 0 0 1-1.13 3.9" />
  </svg>
);
const ForwardRef = forwardRef(IconDrawOutlineSVG);
ForwardRef.displayName = "IconDrawOutline";
export { ForwardRef as IconDrawOutline };
